var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbr-exercises--active-exercises"},[_c('exercises-list-table',{attrs:{"exercises":_vm.exercises,"loading":_vm.loading,"meta":_vm.listMeta},on:{"loadMore":_vm.loadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }